module.exports = __webpack_public_path__ + "static/img/bg-02.00670ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-02.jpg
// module id = fJwU
// module chunks = 96